export default "__VITE_ASSET__1ec2d566__"